import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

/** Grey hollow circle icon per Figma (unverified state). Explicit grey so it never inherits link/primary blue. */
const HOLLOW_CIRCLE_GREY = "#6c757d";

export const HollowCircleIcon = () => (
  <span style={{ lineHeight: 1, color: HOLLOW_CIRCLE_GREY }}>
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 512 512"
      fill="none"
      stroke={HOLLOW_CIRCLE_GREY}
      strokeWidth="60"
      style={{ verticalAlign: "middle" }}
      aria-hidden
    >
      <circle cx="256" cy="256" r="224" />
    </svg>
  </span>
);

/**
 * Renders verification status for phone/fax per Figma Verification Checkmarks design:
 * Verified = green checkmark + "Verified" in green; Unverified = grey hollow circle + "Unverified" in red.
 */
const verificationStatusStyle = { gap: "4px" };

export const VerificationStatus = ({ verified }) => {
  const wrapperClass = "d-inline-flex align-items-center text-nowrap";
  if (verified) {
    return (
      <span className={`${wrapperClass} text-success`} style={verificationStatusStyle} data-testid="verification-status-verified">
        <FontAwesomeIcon icon={faCheckCircle} style={{ fontSize: "0.9em" }} />
        <span>Verified</span>
      </span>
    );
  }
  return (
    <span className={`${wrapperClass} text-danger`} style={verificationStatusStyle} data-testid="verification-status-unverified">
      <HollowCircleIcon />
      <span>Unverified</span>
    </span>
  );
};
